<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<h1 class="toc-title">Contents</h1>
<h2 class="toc"><a href="#/xhtml/04_Introduction"><em class="italic">Introduction</em></a></h2>
<h2 class="tocc"><a href="#/xhtml/05_Chapter01"><span class="tocc"><span class="bold">Chapter 1</span></span> Set in a Silver Sea</a></h2>
<h2 class="tocc"><a href="#/xhtml/06_Chapter02"><span class="tocc"><span class="bold">Chapter 2</span></span> Evidence from Bodies</a></h2>
<h2 class="tocc"><span href="#/xhtml/07_Chapter03" title="Link target outside of Sample"><span class="tocc"><span class="bold">Chapter 3</span></span> The Languages of Britain</span></h2>
<h2 class="tocc"><span href="#/xhtml/08_Chapter04" title="Link target outside of Sample"><span class="tocc"><span class="bold">Chapter 4</span></span> Conquest and Pacification</span></h2>
<h2 class="tocc"><span href="#/xhtml/09_Chapter05" title="Link target outside of Sample"><span class="tocc"><span class="bold">Chapter 5</span></span> Romanisation and Conflict</span></h2>
<h2 class="tocc"><span href="#/xhtml/10_Chapter06" title="Link target outside of Sample"><span class="tocc"><span class="bold">Chapter 6</span></span> Climate Change and Rome</span></h2>
<h2 class="tocc"><span href="#/xhtml/11_Chapter07" title="Link target outside of Sample"><span class="tocc"><span class="bold">Chapter 7</span></span> Crisis in the Third Century</span></h2>
<h2 class="tocc"><span href="#/xhtml/12_Chapter08" title="Link target outside of Sample"><span class="tocc"><span class="bold">Chapter 8</span></span> Britain in the Dominate</span></h2>
<h2 class="tocc"><span href="#/xhtml/13_Chapter09" title="Link target outside of Sample"><span class="tocc"><span class="bold">Chapter 9</span></span> The Archaeology of Collapse</span></h2>
<h2 class="tocc"><span href="#/xhtml/14_Chapter10" title="Link target outside of Sample"><span class="tocc"><span class="bold">Chapter 10</span></span> Tying it all Together into a Narrative</span></h2>
<h2 class="toc"><span href="#/xhtml/15_Final" title="Link target outside of Sample"><em class="italic">Final Thoughts</em></span></h2>
<h2 class="toc"><span href="#/xhtml/16_Time" title="Link target outside of Sample"><em class="italic">Time Line</em></span></h2>
<h2 class="toc"><span href="#/xhtml/17_Bibliography" title="Link target outside of Sample"><em class="italic">Bibliography</em></span></h2>
<h2 class="toc"><span href="#/xhtml/18_Acknowledgements" title="Link target outside of Sample"><em class="italic">Acknowledgements</em></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?4179b238